export function toTitleCase(text?: string | null): string {
  if (!text) {
    return "";
  }

  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

/* Returns a string like Make Model */
export function getMakeModel(
  make: string | null,
  model: string | null
): string {
  let makeModel = "";
  makeModel += make ?? "";
  makeModel += makeModel.length && (model ? ` ${model}` : "");

  return makeModel;
}

export const getNcb = ncb => {
  let displayValue;
  let value;

  ncb = ncb?.toString();

  if (ncb?.includes("%")) {
    displayValue = ncb;
    value = parseInt(ncb?.split("%")[0]);
  } else {
    displayValue = ncb + "%";
    value = parseInt(ncb);
  }

  return {
    displayValue,
    value
  };
};

export default {};
